import { Model, Property } from '@shared/model-system';

export interface IDivision {
  id: string;
  name?: string;
}

/** Team model using the model system */
export class Team extends Model {
  @Property() public id: string;
  @Property() public name: string;
  @Property() public description: string;
  @Property() public memberCount: number;
  @Property() public division: IDivision;
}
